import * as React from "react";
import { forwardRef } from "react";
const SvgTimeseries = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 26 13" ref={ref} {...props}><path stroke="#4A4A4A" strokeWidth={1.5} d="M1 12.5 4 9l6.5 2 4-7.5 3.5 5 6.5-7" /></svg>;
const ForwardRef = forwardRef(SvgTimeseries);
export default ForwardRef;